/** @fileoverview Prevents the document itself from scrolling while a full-height view is open. */

import { useLayoutEffect } from 'react';

/** Locks html/body scrolling for the lifetime of the calling component. */
export function useLockDocumentScroll() {
  useLayoutEffect(() => {
    const { body, documentElement } = document;
    const previousHtmlOverflow = documentElement.style.overflow;
    const previousBodyOverflow = body.style.overflow;
    documentElement.style.overflow = 'hidden';
    body.style.overflow = 'hidden';

    return () => {
      documentElement.style.overflow = previousHtmlOverflow;
      body.style.overflow = previousBodyOverflow;
    };
  }, []);
}
